const Skills = () =>{
  return (
  <section className="skills section">
    <h2 className="heading">Skills</h2>
    <div className="item">
        <div className="gridSkill">
          <ul>
            <span className="skill-category">Programming Languages</span>&#187;
            <li>C</li>
            <li>C++</li>
            <li>Python</li>
            <li>JavaScript</li>
            <li>Java</li>
            <li>Latex</li>
          </ul>
          <ul>
            <span className="skill-category">Web Technologies</span>&#187;
            <li>HTML</li>
            <li>CSS</li>
            <li>Django</li>
            <li>nodeJS</li>
            <li>ReactJS</li>
            <li>jQuery</li>
          </ul>
          <ul>
            <span className="skill-category">Miscellaneous</span>&#187;
            <li>git</li>
            <li>React Native</li>
            <li>Android Programming</li>
          </ul>
          <ul>
            <span className="skill-category">Database Management</span>&#187;
            <li> Firebase</li>
            <li>MySQL</li>
          </ul>
        </div>
      </div>
  </section>);
}

export default Skills;